export default __webpack_public_path__ + "static/media/takto.6cafd4b5.svg";